import { handleVersionMismatch } from 'actions/versionSync';
import * as MapActionTypes from 'actiontypes/map';
import * as StoryletActionCreators from 'actions/storylet';
import { fetch as fetchCards } from 'actions/cards';
import { VersionMismatch } from 'services/BaseService';
import MapService from 'services/MapService';
import hideMap from './hideMap';
import setCurrentArea from './setCurrentArea';
import { IMapService } from 'types/map';
import { IAppState } from 'types/app';

const changeLocationRequested = () => ({
  type: MapActionTypes.CHANGE_LOCATION_REQUESTED,
});

const changeLocationSuccess = ({ message }: { message: string }) => ({
  type: MapActionTypes.CHANGE_LOCATION_SUCCESS,
  payload: { message },
});

const changeLocationFailure = (error: any) => ({
  type: MapActionTypes.CHANGE_LOCATION_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * CHANGE LOCATION
 -----------------------------------------------------------------------------*/
export default changeLocation(new MapService());

export function changeLocation(service: IMapService) {
  const defaultOptions = {
    closeMap: true,
  };

  return (areaId: number, options?: { closeMap: boolean }) => async (dispatch: Function, getState: () => IAppState) => {
    const { closeMap } = { ...defaultOptions, ...options };
    // Get the value of `showOps` before changing location
    const { map: { showOps: showOpsBeforeMove } } = getState();
    dispatch(changeLocationRequested());
    try {
      const { data } = await service.changeLocation(areaId);
      dispatch(changeLocationSuccess(data));
      if (data.isSuccess) {
        dispatch(setCurrentArea(data.area));
        dispatch(StoryletActionCreators.fetchAvailable());
        if (closeMap) {
          dispatch(hideMap());
        }

        // Get the value of `showOps` after changing location
        const { map: { showOps: showOpsAfterMove } } = getState();
        // If we weren't showing opp cards before moving, but we are now,
        // then fetch them
        if (!showOpsBeforeMove && showOpsAfterMove) {
          dispatch(fetchCards());
        }
      }
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      console.error(error);
      dispatch(changeLocationFailure(error));
      return error;
    }
  };
}
